module.exports = {
  id: 32,
  name: 'Arm Circles',
  categories: ['flexibility', 'arms', 'coordination'],
  sports: [
    'baseball',
    'basketball',
    'boxing',
    'cricket',
    'dance',
    'football',
    'golf',
    'hockey',
    'lacrosse',
    'martial-arts',
    'gymnastics',
    'rugby',
    'soccer',
    'swimming',
    'tennis',
    'track',
    'volleyball',
  ],
  difficulty: 'beginner',
  skill: 'Flexibility',
  points: 8,
  instructions:
    'Arm Circles make your arms strong and flexible! Stand with your feet apart, hold your arms out to the sides, then move them in big circles forward and backward! This makes you strong and flexible!',
  timedInstructions: [
    {
      time: 2,
      text: 'Ready to circle your arms?',
    },
    {
      time: 4,
      text: 'Here we go!',
    },
    {
      time: 5,
      text: '3, 2, 1',
    },
    {
      time: 8,
      text: 'Circle forward',
    },
    {
      time: 10,
      text: 'Circle backward',
    },
    {
      time: 12,
      text: 'Circle forward',
    },
    {
      time: 14,
      text: 'Circle backward',
    },
    {
      time: 16,
      text: 'Circle forward',
    },
    {
      time: 18,
      text: 'Circle backward',
    },
    {
      time: 20,
      text: 'Keep going, champion!',
    },
    {
      time: 22,
      text: 'Circle forward',
    },
    {
      time: 24,
      text: 'Circle backward',
    },
    {
      time: 26,
      text: 'Circle forward',
    },
    {
      time: 28,
      text: 'Circle backward',
    },
    {
      time: 30,
      text: "You're doing amazing!",
    },
    {
      time: 32,
      text: 'Circle forward',
    },
    {
      time: 34,
      text: 'Circle backward',
    },
    {
      time: 36,
      text: 'Great job! Take a break',
    },
    {
      time: 39,
      text: 'Breathe in and out',
    },
    {
      time: 41,
      text: 'Ready for round two!',
    },
    {
      time: 43,
      text: '3, 2, 1',
    },
    {
      time: 46,
      text: 'Circle forward',
    },
    {
      time: 48,
      text: 'Circle backward',
    },
    {
      time: 50,
      text: 'Circle forward',
    },
    {
      time: 52,
      text: 'Circle backward',
    },
    {
      time: 54,
      text: 'Circle forward',
    },
    {
      time: 56,
      text: 'Circle backward',
    },
    {
      time: 58,
      text: 'Incredible arm power!',
    },
    {
      time: 60,
      text: 'Circle forward',
    },
    {
      time: 62,
      text: 'Circle backward',
    },
    {
      time: 64,
      text: 'Circle forward',
    },
    {
      time: 66,
      text: 'Circle backward',
    },
    {
      time: 68,
      text: "You're getting stronger!",
    },
    {
      time: 70,
      text: 'Circle forward',
    },
    {
      time: 72,
      text: 'Circle backward',
    },
    {
      time: 74,
      text: 'Great job! Take another break',
    },
    {
      time: 77,
      text: 'Breathe in and out',
    },
    {
      time: 79,
      text: 'Ready for round three!',
    },
    {
      time: 81,
      text: '3, 2, 1',
    },
    {
      time: 84,
      text: 'Circle forward',
    },
    {
      time: 86,
      text: 'Circle backward',
    },
    {
      time: 88,
      text: 'Circle forward',
    },
    {
      time: 90,
      text: 'Circle backward',
    },
    {
      time: 92,
      text: 'Circle forward',
    },
    {
      time: 94,
      text: 'Circle backward',
    },
    {
      time: 96,
      text: 'Keep going, superstar!',
    },
    {
      time: 98,
      text: 'Circle forward',
    },
    {
      time: 100,
      text: 'Circle backward',
    },
    {
      time: 102,
      text: 'Circle forward',
    },
    {
      time: 104,
      text: 'Circle backward',
    },
    {
      time: 106,
      text: 'Almost there, champion!',
    },
    {
      time: 108,
      text: 'Circle forward',
    },
    {
      time: 110,
      text: 'Circle backward',
    },
    {
      time: 112,
      text: 'Great job! Take a final break',
    },
    {
      time: 115,
      text: 'Breathe in and out',
    },
    {
      time: 117,
      text: 'Ready for the final round!',
    },
    {
      time: 119,
      text: '3, 2, 1',
    },
    {
      time: 122,
      text: 'Circle forward',
    },
    {
      time: 124,
      text: 'Circle backward',
    },
    {
      time: 126,
      text: 'Circle forward',
    },
    {
      time: 128,
      text: 'Circle backward',
    },
    {
      time: 130,
      text: 'Circle forward',
    },
    {
      time: 132,
      text: 'Circle backward',
    },
    {
      time: 134,
      text: 'Final push, hero!',
    },
    {
      time: 136,
      text: 'Circle forward',
    },
    {
      time: 138,
      text: 'Circle backward',
    },
    {
      time: 140,
      text: 'Circle forward',
    },
    {
      time: 142,
      text: 'Circle backward',
    },
    {
      time: 144,
      text: 'You did it, champion!',
    },
    {
      time: 146,
      text: "Awesome job, you're an arm master!",
    },
  ],
};
